import QInfiniteScroll from './QInfiniteScroll'

export default QInfiniteScroll
